(function () {
  var MQ = window.matchMedia('(max-width: 1024.98px)');
  var THRESHOLD = 48;
  var ticking = false;

  function luminance(r, g, b) {
    var a = [r, g, b].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  }

  function parseHex(hex) {
    var h = hex.replace('#', '');
    if (h.length === 3) {
      h = h
        .split('')
        .map(function (c) {
          return c + c;
        })
        .join('');
    }
    if (h.length < 6) return null;
    return [
      parseInt(h.slice(0, 2), 16),
      parseInt(h.slice(2, 4), 16),
      parseInt(h.slice(4, 6), 16),
    ];
  }

  function parseRgb(str) {
    if (!str) return null;
    str = str.trim();
    var m = str.match(/rgba?\(([^)]+)\)/);
    if (m) {
      var p = m[1].split(',').map(function (s) {
        return parseFloat(s.trim());
      });
      if (p.length >= 4 && p[3] < 0.08) return null;
      return p.length >= 3 ? p.slice(0, 3) : null;
    }
    if (str.charAt(0) === '#') return parseHex(str);
    return null;
  }

  function readBgRgb(el) {
    if (!el) return null;
    var rgb = parseRgb(getComputedStyle(el).backgroundColor);
    if (rgb) return rgb;
    var cssVar = getComputedStyle(el).getPropertyValue('--color-background').trim();
    return parseRgb(cssVar);
  }

  function getHeaderElement() {
    return (
      document.querySelector('.shopify-section-header-sticky header.header') ||
      document.querySelector('.section-header header.header') ||
      document.querySelector('.section-header')
    );
  }

  function updateHeaderTheme() {
    var header = getHeaderElement();
    if (!header) return;

    var rgb =
      readBgRgb(header) ||
      readBgRgb(header.closest('.section-header')) ||
      readBgRgb(document.body);

    /* Transparent header reads as rgba(0,0,0,0) — default to light bg / dark wordmark */
    var dark = rgb ? luminance(rgb[0], rgb[1], rgb[2]) < 0.45 : false;
    document.body.classList.toggle('teavity-header-dark', dark);
    document.body.classList.toggle('teavity-header-light', !dark);
  }

  function updateScroll() {
    ticking = false;
    if (!MQ.matches) {
      document.body.classList.remove(
        'teavity-mobile-scrolled',
        'teavity-header-dark',
        'teavity-header-light'
      );
      return;
    }

    var scrolled = window.scrollY > THRESHOLD;
    document.body.classList.toggle('teavity-mobile-scrolled', scrolled);
    if (scrolled) {
      updateHeaderTheme();
    } else {
      document.body.classList.remove('teavity-header-dark', 'teavity-header-light');
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateScroll);
    }
  }

  if (MQ.addEventListener) {
    MQ.addEventListener('change', updateScroll);
  } else if (MQ.addListener) {
    MQ.addListener(updateScroll);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('DOMContentLoaded', updateScroll);
  updateScroll();
})();
